import { Component } from "@angular/core";

@Component({
    selector: 'requests-with-activities-report',
    templateUrl: './requests-with-activities-report.component.html',
    styleUrls: [
        '../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class RequestsWithActivitiesReportComponent {

    public reportFileNamePrefix: string = 'Заявки_C_Активностями';
}
